module.exports = __webpack_public_path__ + "img/4.e73628b4.png";